module.exports = __webpack_public_path__ + "static/media/style.26ddd5a0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/style.scss
// module id = 2063
// module chunks = 0